/**
 * @Copyright (c) 2021 DigiNet
 * @author NHATLONG
 * @create 23/7/2021
 * @Example
 */

import Api from '../../../services/api.js';
import * as types from '../../../../src/actions/types';

export function loadForm(params, cb) {
    return (dispatch) => {
        Api.put('/w17f5565/get-list', params)
            .then(result => {
                if (result && result.code && result.code !== 200) {
                    if (cb) cb(result, null);
                } else {
                    if (cb) cb(null, result.data);
                    dispatch(loadFormComplete(result.data));
                }
            });
    };
}

function loadFormComplete(data) {
    return {
        type: types.W17F5565_GET_FORM_COMPLETE,
        data: data
    }
}
